// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../index';

export const NonSkuCaratWeightRangeFragmentDoc = `
    fragment nonSkuCaratWeightRange on NonSkuCaratWeightRange {
  __typename
  min
  max
}
    `;